import MessageFormat from "messageformat";

/**
 * @author ybh
 * The text formatting component messageFormat is used here for multi-language extension and design.  Related documents
 *  https://segmentfault.com/a/1190000013202109
 */


/**
 *  过滤器 主要用于过滤字段
 * @type {{beforeBalanceOrigin: (function(*): string)}}
 */
const filters = {
  beforeBalanceOrigin: function(values) {
    if (!values.oldOriginBalance) {
      return "缺少数据";
    }
    const { role, originRole, oldOriginBalance } = values;

    return role > originRole ? "隐藏" : oldOriginBalance;
  },
  beforeBalanceTarget: function(values) {
    if (values.originBalance === undefined) {
      return "缺少数据";
    }
    const { role, targetRole, oldTargetBalance } = values;
    let temp = 0;
    if (oldTargetBalance !== undefined) {
      temp = oldTargetBalance;
    }
    return role > targetRole ? "隐藏" : temp;
  },
  afterBalanceOrigin: function(values) {
    if (values.originBalance === undefined) {
      return "缺少数据";
    }


    const { role, originRole, originBalance } = values;
    let temp = 0;
    if (originBalance !== undefined) {
      temp = originBalance;
    }
    return role > originRole ? "隐藏" : temp;
  },
  afterBalanceTarget: function(values) {
    if (values.targetBalance === undefined) {
      return "缺少数据";
    }

    const { role, targetRole, targetBalance } = values;
    let temp = 0;

    if (targetBalance !== undefined) {
      temp = targetBalance;
    }
    return role > targetRole ? "隐藏" : temp;
  }

};

export default class CustomFormatter {
  constructor(options = {}) {
    this._locale = options.locale || "en-US";
    this._formatter = new MessageFormat(this._locale);
    this._formatter.setIntlSupport(true);
    this._caches = Object.create(filters);
  }

  interpolate(message, values) {
    let fn = this._caches[message];
    if (!fn) {
      fn = this._formatter.compile(message, this._locale);
    } else {
      // console.log(message,values.oldOriginBalance);
    }
    return [fn(values)];
  }


}








// WEBPACK FOOTER //
// ./src/api/lang/formatter/formatter.js